/* unplugin-vue-components disabled */import script from "./spacer.vue?vue&type=script&lang=js"
export * from "./spacer.vue?vue&type=script&lang=js"

import "./spacer.vue?vue&type=style&index=0&id=3dc4a010&lang=scss"

const __exports__ = script;

export default __exports__